import { render } from "./SidebarLogo.vue?vue&type=template&id=e20eaf50&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=e20eaf50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e20eaf50"

export default script